import React, { useState } from "react"
import copy from "copy-to-clipboard"
import { Button } from "@sumup/circuit-ui"
import { Copy } from "react-feather"
import "./ClipboardButton.css"

export default function ClipboardButton({
  textForClipboard,
}: {
  textForClipboard: string
}) {
  const [state, setState] = useState<{ feedback?: string }>({
    feedback: undefined,
  })
  const handleClick = () => {
    const success = copy(textForClipboard)
    return success ? handleSuccess() : handleError()
  }

  const handleSuccess = () => {
    setState({ feedback: "Copied!" })
    setTimeout(() => setState({ feedback: undefined }), 500)
  }

  const handleError = () => {
    setState({ feedback: "Couldn’t copy text to clipboard" })
  }

  return (
    <div style={{ display: "flex", marginTop: "auto", position: "relative" }}>
      <small
        role='alert'
        className={`clipboard-feedback ${state.feedback ? "" : "hidden"}`}
      >
        Copied
      </small>
      <Button
        variant='tertiary'
        size='kilo'
        className='clipboard-button'
        onClick={handleClick}
      >
        <Copy /> <span>Copy to clipboard</span>
      </Button>
    </div>
  )
}
